<template>

    <div class="prescription-popup">
        <div class="content-custom-fit">
            <div class="popup-header">
              <span class="popup-header-title">Files generated</span>
              <div class="header-right">
                <b-button variant="secondary" :href="'https://api.sens-eye.fr/api/download-files/'+fittingResult.id"><img src="@/assets/images/dl.svg" width="15" /><span>Download all the files</span></b-button>
                <div class="cross" @click="closePopup()"><img src="@/assets/images/close.svg" /></div>
              </div>
            </div>


            <div class="scan-toggles">
              <div :class="{'active':view=='stl'}"  @click="view='stl'" class="toggle">
                <span>3D Files</span>
              </div>
              <div :class="{'active':view=='svg'}" @click="view='svg'" class="toggle">
                <span >Technical 2D File</span>
              </div>
            </div>

            <div v-if="view=='stl'" class="three-content" >
              <div class="fs-icon" @click="openFullscreen('stl')"><img src="@/assets/images/fs.svg" /></div>
              <custom-fit-stl-canvas :stl-url="stlUrl" />
              <div class="buttons-dl">
                <b-button variant="custom" :href="'https://api.sens-eye.fr/api/download-files-3d/'+fittingResult.id"><img src="@/assets/images/dl.svg" width="15" /><span>Download all 3D files</span></b-button>
                <div class="button-separately">
                  <div @click="displaySeparately=!displaySeparately">
                    <span>Download separately</span>
                    <img src="@/assets/images/arrow.svg" v-if="!displaySeparately" width="6" />
                    
                  </div>
                  <div class="content-separately" v-if="displaySeparately">
                    <b-button variant="primary" :href="stlFrontUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Face</span></b-button>
                    <b-button variant="primary" :href="stlTempleLUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Left temple</span></b-button>
                    <b-button variant="primary" :href="stlTempleRUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Right temple</span></b-button>
                    <!--<b-button v-if="subdUrl" variant="primary" :href="subdUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>SubD</span></b-button>-->
                  </div>
                  <img src="@/assets/images/arrow.svg" class="open" @click="displaySeparately=!displaySeparately" v-if="displaySeparately" width="6" />
                </div>
              </div>
            </div>
            <div v-if="view=='svg'" class="svg-content" >
              <div class="fs-icon" @click="openFullscreen('svg')"><img src="@/assets/images/fs.svg" /></div>
              <img :src="svgUrl" width="100%"  />
              <div class="buttons-dl">
                <b-button variant="custom" :href="svgUrl" download target="_blank"><img src="@/assets/images/dl.svg" width="15" /><span>Download SVG</span></b-button>
               
              </div>

            </div>

            <div v-if="fullscreenType" class="fullscreen-preview-overlay">
              <div class="fullscreen-preview-content">
                <div class="fullscreen-close" @click="closeFullscreenPreview()">
                  <img src="@/assets/images/close.svg" />
                </div>

                <div v-if="fullscreenType === 'stl'" class="fullscreen-preview-body">
                  <custom-fit-stl-canvas :stl-url="stlUrl" />
                </div>

                <div v-if="fullscreenType === 'svg'" class="fullscreen-preview-body fullscreen-svg-body">
                  <img :src="svgUrl" />
                </div>

                <div class="buttons-dl"  v-if="fullscreenType === 'stl'">
                  <b-button variant="custom" :href="'https://api.sens-eye.fr/api/download-files-3d/'+fittingResult.id"><img src="@/assets/images/dl.svg" width="15" /><span>Download all 3D files</span></b-button>
                  <div class="button-separately">
                    <div @click="displaySeparately=!displaySeparately">
                      <span>Download separately</span>
                      <img src="@/assets/images/arrow.svg" v-if="!displaySeparately" width="6" />
                      
                    </div>
                    <div class="content-separately" v-if="displaySeparately">
                      <b-button variant="primary" :href="stlFrontUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Face</span></b-button>
                      <b-button variant="primary" :href="stlTempleLUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Left temple</span></b-button>
                      <b-button variant="primary" :href="stlTempleRUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>Right temple</span></b-button>
                      <!--<b-button v-if="subdUrl" variant="primary" :href="subdUrl" download><img src="@/assets/images/dl.svg" width="15" /><span>SubD</span></b-button>-->
                    </div>
                    <img src="@/assets/images/arrow.svg" class="open" @click="displaySeparately=!displaySeparately" v-if="displaySeparately" width="6" />
                  </div>
                </div>
               

                <b-button
                  v-if="fullscreenType === 'svg'"
                  class="fullscreen-download-btn"
                  variant="primary"
                  :href="svgUrl"
                  download
                >
                  <img src="@/assets/images/dl.svg" width="15" />
                  <span>Download SVG</span>
                </b-button>
              </div>
            </div>

           
            
        </div>
       
    </div>
  </template>
  
  
  <script>

  import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
  import {APIRequest, Auth} from '@simb2s/senseye-sdk'
  import { VueGoodTable } from 'vue-good-table'
  import ScanPopup from '../../components/ScanPopup.vue'
  import AdjustmentReport from '../order-review/AdjustmentReport.vue'
  import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import emitter from 'tiny-emitter/instance'
  import ScanCanvas from './ScanCanvas.vue'
  import CustomFitStlCanvas from './CustomFitStlCanvas.vue'

  export default {
    components: {
      BCard,
      BCardText,
      VueGoodTable,
    BAvatar,
    ScanCanvas,
    CustomFitStlCanvas,
      BOverlay,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      BModal,
      BButton,
      BRow,
      ScanPopup,
      PrescriptionPopup,
      AdjustmentReport
    },
    props:['stlUrl','svgUrl','stlFrontUrl','stlTempleLUrl','stlTempleRUrl','subdUrl','fittingResult'],
    data() {
      return {
        view:'stl',
        displaySeparately:false,
        fullscreenType: null,
      }
    },
    computed: {
     
    },
    methods:{
        closePopup() {
            this.$emit('closeDownloadFilesPopupEv')
        },
        triggerFileDownload(url, fallbackFilename) {
            if (!url) return
            const link = document.createElement('a')
            link.href = url
            link.download = this.getFilenameFromUrl(url, fallbackFilename)
            link.target = '_blank'
            link.rel = 'noopener'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        getFilenameFromUrl(url, fallbackFilename) {
            try {
                const pathname = new URL(url, window.location.origin).pathname
                const fileName = pathname.split('/').pop()
                return fileName || fallbackFilename
            } catch (e) {
                return fallbackFilename
            }
        },
        downloadAllFiles3D() {
            this.triggerFileDownload(this.stlUrl, 'model_mesh.stl')
            
            setTimeout(() => {
              this.triggerFileDownload(this.stlFrontUrl, 'model.svg')
              setTimeout(() => {
                this.triggerFileDownload(this.stlTempleLUrl, 'model_templel.svg')
                setTimeout(() => {
                  this.triggerFileDownload(this.stlTempleRUrl, 'model_templer.svg')
                  
                }, 100)
              }, 100)
              

            }, 100)
        },
        downloadAllFiles() {
            this.triggerFileDownload(this.stlUrl, 'model_mesh.stl')
            
            setTimeout(() => {
              this.triggerFileDownload(this.stlFrontUrl, 'model.svg')
              setTimeout(() => {
                this.triggerFileDownload(this.stlTempleLUrl, 'model_templel.svg')
                setTimeout(() => {
                  this.triggerFileDownload(this.stlTempleRUrl, 'model_templer.svg')
                  setTimeout(() => {
                    this.triggerFileDownload(this.svgUrl, 'drawing.svg')
                    if(this.subdUrl)
                    {
                      setTimeout(() => {
                        this.triggerFileDownload(this.subdUrl, 'subD.3dm')
                      }, 100)
                    }
                    
                  }, 100)
                }, 100)
              }, 100)
              

            }, 100)
        },
        openFullscreen(type) {
            this.fullscreenType = type
        },
        closeFullscreenPreview() {
            this.fullscreenType = null
        },
    },
    beforeUnmount() {
     
    }
  
  }
  
  
    </script>
  
    <style scoped lang="scss" >
  @import '@core/scss/vue/libs/vue-good-table.scss';
 
 .buttons-dl
 {
  position:absolute;
  bottom:20px;
  left:20px;
  font-size:13px;
  font-weight:400 !important;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  gap:10px;
  .button-separately
  {
    >div{
      display:flex;
      align-items: center;
      gap:10px;
    }
    .open 
    {
      transform: rotate(180deg);
    }
    display:flex;
    transition: all 0.3s ease;
    background:#fff !important;
    border-radius: 5px;
    padding-left:15px;
    padding-right:15px;
    height:45px;
    cursor: pointer;
    display:flex;
    align-items: center;
    gap:10px;
    .content-separately
    {
      display:flex;
      align-items: center;
      gap:10px;
      .btn,a{
        display:flex;
        align-items: center;
        gap:10px;
      }
    }
   
  }
  .btn-custom

  {
    display:flex;
      align-items: center;
      gap:10px;
      padding:15px !important;
    background:#fff !important;
  }
 }
  .header-right
  {
    display:flex;
    align-items: center;
    gap:10px;
    a,button
    {
      display:flex;
      align-items: center;
      gap:10px;
    }
  }
  .scan-toggles
  {
    margin-left:auto;
    margin-right:auto;
    padding:5px;
    background: #f1f1f1;
    max-width: 420px;
    border-radius: 5px;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    .toggle
    {
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 5px;
      flex:1;
      color: #000;
      text-align: center;
    }
    .toggle.active
    {
      background: #fff;
    }
  }
  .three-content
  {
    position:relative;
    background: #f1f1f1;
    padding:20px;
    border-radius: 5px;
    width:100%;
    height:30vw;
    max-height: 500px;
    min-height: 300px;
  }
  .fs-icon
  {
    position:absolute;
    top: 10px;
    right:10px;
    z-index: 2;
    width:32px;
    cursor: pointer;
    height:32px;
    display:flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 5px;
    img
    {
      width:15px;
      height:15px;
    }
  }
  .svg-content
  {
    position:relative;
    background: #f1f1f1;
    padding:20px;
    border-radius: 5px;
    width:100%;
    height:30vw;
    max-height: 500px;
    min-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
    img
    {
      background: #fff;
    }
  }
  .fullscreen-preview-overlay
  {
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index: 99999999;
    background: rgba(0,0,0,0.2);
    display:flex;
    align-items:center;
    justify-content:center;
    padding: 20px;
  }
  .fullscreen-preview-content
  {
    position: relative;
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    border-radius: 8px;
    padding: 20px;
    padding-bottom: 80px;
  }
  .fullscreen-preview-body
  {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
  }
  .fullscreen-svg-body
  {
    display:flex;
    align-items:center;
    justify-content:center;
    overflow:auto;
    img
    {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
  .fullscreen-close
  {
    position:absolute;
    top:10px;
    right:10px;
    z-index:2;
    cursor: pointer;
    width:32px;
    height:32px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:5px;
    background: #fff;
    img
    {
      width:10px;
      transform: rotate(180deg);
    }
  }
  .fullscreen-download-btn
  {
    position:absolute;
    bottom:20px;
    left:20px;
    background:#fff !important;
    display:flex;
    align-items:center;
    gap:8px;
  }
 .cross
 {
    cursor: pointer;
    width:32px;
   
    height:32px;
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #f1f1f1;
    img
    {
      transform: rotate(180deg);
        width:10px;
    }
 }
  .popup-header
  {
    display: flex;
    position:relative;
    z-index: 3;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px;
    .popup-header-title
    {
        font-size:22px;
        font-weight:600;
    }
  }
  .title-icon
  {
    width:32px;
    height:32px;
    display:flex;
    background: #f1f1f1;
    border-radius: 5px;
  
    align-items: center;
    justify-content: center;
  }
  .prescription-popup
  {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 9999999;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    .content-custom-fit
    {
      
       position: relative;
        width:80% ;
       max-width:920px;
       min-width: 920px;
   
        background: #fff;
        border-radius: 5px;
        padding: 20px;
    }
  }
 

  </style>